module.exports = __webpack_public_path__ + "assets/images_base/facebook-logo-blue.svg?v=a3144429";